{
  "id": "campaign-151",
  "name": "Wildflower Pasture",
  "seed": "campaign:151",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "...............k....",
    "......k.............",
    "................k...",
    "..........Y...T....T",
    "x...................",
    "......~.............",
    "....wwwwww+w........",
    "www+w......www,.....",
    ".............www+www",
    ".....#..............",
    ".............T......",
    "....................",
    "....................",
    "...Y................",
    "....................",
    ".............m......",
    "...........k.mm...m.",
    ".............m...mmm",
    ".....T..............",
    "S...........#...#..."
  ],
  "critters": [
    {
      "kind": "deer",
      "x": 4,
      "y": 18
    },
    {
      "kind": "deer",
      "x": 4,
      "y": 17
    },
    {
      "kind": "fox",
      "x": 10,
      "y": 9
    },
    {
      "kind": "fox",
      "x": 4,
      "y": 4
    },
    {
      "kind": "stag",
      "x": 17,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 0
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 16,
      "y": 18
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 19
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 18
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 15
    },
    {
      "kind": "repair",
      "x": 16,
      "y": 12
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 11,
      "y": 9,
      "w": 7,
      "h": 7
    },
    {
      "x": 14,
      "y": 2,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 151,
  "biome": "meadow",
  "par": {
    "reel": 14057,
    "push": 12470,
    "selfPropelled": 11352,
    "tractor": 9250,
    "zeroTurn": 8167,
    "fairway": 4823
  },
  "goldTime": {
    "reel": 14057,
    "push": 12054,
    "selfPropelled": 11112,
    "tractor": 9250,
    "zeroTurn": 8167,
    "fairway": 4586
  },
  "routeTries": {
    "par": {
      "reel": 2,
      "push": 20,
      "selfPropelled": 10,
      "tractor": 4,
      "zeroTurn": 5,
      "fairway": 19
    },
    "gold": {
      "reel": 2,
      "push": 27,
      "selfPropelled": 38,
      "tractor": 4,
      "zeroTurn": 5,
      "fairway": 39
    }
  }
}
